var _rect, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrkfstioLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 32,
    viewBox: "0 0 92 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.84375,
    y: 0.460938,
    width: 91.1543,
    height: 31.0771,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 23,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65234 5H29.6528V27.0002H7.65234V5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8383_108125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 23,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6489 16.0001C29.6489 22.0752 24.7236 27.0002 18.6488 27.0002C12.5738 27.0002 7.64844 22.0752 7.64844 16.0001C7.64844 9.92504 12.5738 5 18.6488 5C24.7236 5 29.6489 9.92504 29.6489 16.0001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8383_108125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 4.57031H30.0785V27.43H7.21875V4.57031Z",
    fill: "#2D6BFF"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 8,
    width: 12,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 8.64062H24.1485V23.361H13.1484V8.64062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8383_108125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 8,
    width: 12,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5286 8.66602C16.5364 8.69793 13.1523 12.0512 13.1523 17.6921C13.1523 19.522 14.1398 23.3333 18.5113 23.3333C22.7422 23.3333 24.1525 20.2841 24.1525 17.6921C24.1525 12.3563 21.0499 8.69793 18.5294 8.66602",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8383_108125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 4.57031H30.0824V27.43H7.22266V4.57031Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 14,
    width: 5,
    height: 5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6523 14.4531H22.2427V18.0625H18.6523V14.4531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8383_108125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 14,
    width: 5,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2016 18.016C22.2016 16.0602 20.616 14.4746 18.6602 14.4746V18.016H22.2016Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_8383_108125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22656 4.56836H30.0863V27.4281H7.22656V4.56836Z",
    fill: "#FBD405"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 5,
    height: 4
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6523 18.0059H22.2427V21.5844H18.6523V18.0059Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_8383_108125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 5,
    height: 4
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6602 21.5551C20.616 21.5551 22.2016 19.9695 22.2016 18.0137H18.6602V21.5551Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_8383_108125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22656 4.56836H30.0863V27.4281H7.22656V4.56836Z",
    fill: "#2D6BFF"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 18,
    width: 4,
    height: 4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0586 18.0078H18.6523V21.5864H15.0586V18.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_8383_108125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_8383_108125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 18,
    width: 4,
    height: 4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1133 18.0156C15.1133 19.9715 16.6988 21.5571 18.6547 21.5571V18.0156H15.1133Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_8383_108125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22656 4.57031H30.0863V27.43H7.22656V4.57031Z",
    fill: "#FF5ABD"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5454 21.168C37.8921 21.168 37.2667 20.8693 36.6694 20.272H36.6274L36.4874 21H35.2134V11.116H36.8234V13.664L36.7814 14.812C37.0707 14.56 37.3881 14.3547 37.7334 14.196C38.0787 14.0373 38.4241 13.958 38.7694 13.958C39.6281 13.958 40.2954 14.2753 40.7714 14.91C41.2474 15.5447 41.4854 16.3893 41.4854 17.444C41.4854 18.228 41.3454 18.9 41.0654 19.46C40.7854 20.0107 40.4214 20.4353 39.9734 20.734C39.5347 21.0233 39.0587 21.168 38.5454 21.168ZM38.2094 19.838C38.6667 19.838 39.0494 19.6373 39.3574 19.236C39.6654 18.8347 39.8194 18.2467 39.8194 17.472C39.8194 16.7813 39.7027 16.2447 39.4694 15.862C39.2361 15.4793 38.8581 15.288 38.3354 15.288C37.8501 15.288 37.3461 15.5447 36.8234 16.058V19.264C37.0661 19.4693 37.3041 19.6187 37.5374 19.712C37.7801 19.796 38.0041 19.838 38.2094 19.838ZM43.1021 21V14.126H44.4321L44.5441 15.344H44.6001C44.8427 14.896 45.1367 14.5553 45.4821 14.322C45.8274 14.0793 46.1821 13.958 46.5461 13.958C46.8727 13.958 47.1341 14.0047 47.3301 14.098L47.0501 15.498C46.9287 15.4607 46.8167 15.4327 46.7141 15.414C46.6114 15.3953 46.4854 15.386 46.3361 15.386C46.0654 15.386 45.7807 15.4933 45.4821 15.708C45.1834 15.9133 44.9267 16.2773 44.7121 16.8V21H43.1021ZM48.3247 21V11.116H49.9067V17.29H49.9487L52.4967 14.126H54.2607L51.9087 16.926L54.4987 21H52.7487L50.9847 18.018L49.9067 19.25V21H48.3247ZM55.9192 21V15.4H54.9952V14.196L55.9192 14.126V13.412C55.9192 12.6933 56.0965 12.1053 56.4512 11.648C56.8059 11.1813 57.3892 10.948 58.2012 10.948C58.4439 10.948 58.6772 10.9713 58.9012 11.018C59.1252 11.0647 59.3119 11.1207 59.4612 11.186L59.1532 12.39C58.9012 12.278 58.6492 12.222 58.3972 12.222C57.8185 12.222 57.5292 12.6093 57.5292 13.384V14.126H58.8732V15.4H57.5292V21H55.9192ZM61.9185 21.168C61.4518 21.168 60.9852 21.0793 60.5185 20.902C60.0518 20.7153 59.6505 20.4867 59.3145 20.216L60.0705 19.18C60.3785 19.4133 60.6865 19.6 60.9945 19.74C61.3025 19.88 61.6292 19.95 61.9745 19.95C62.3478 19.95 62.6232 19.8707 62.8005 19.712C62.9778 19.5533 63.0665 19.3573 63.0665 19.124C63.0665 18.928 62.9918 18.7693 62.8425 18.648C62.7025 18.5173 62.5205 18.4053 62.2965 18.312C62.0725 18.2093 61.8392 18.1113 61.5965 18.018C61.2978 17.906 60.9992 17.7707 60.7005 17.612C60.4112 17.444 60.1732 17.234 59.9865 16.982C59.7998 16.7207 59.7065 16.3987 59.7065 16.016C59.7065 15.4093 59.9305 14.9147 60.3785 14.532C60.8265 14.1493 61.4332 13.958 62.1985 13.958C62.6838 13.958 63.1178 14.042 63.5005 14.21C63.8832 14.378 64.2145 14.5693 64.4945 14.784L63.7525 15.764C63.5098 15.5867 63.2625 15.4467 63.0105 15.344C62.7678 15.232 62.5112 15.176 62.2405 15.176C61.8952 15.176 61.6385 15.2507 61.4705 15.4C61.3025 15.54 61.2185 15.7173 61.2185 15.932C61.2185 16.2027 61.3585 16.408 61.6385 16.548C61.9185 16.688 62.2452 16.8233 62.6185 16.954C62.9358 17.066 63.2438 17.206 63.5425 17.374C63.8412 17.5327 64.0885 17.7427 64.2845 18.004C64.4898 18.2653 64.5925 18.6107 64.5925 19.04C64.5925 19.628 64.3638 20.132 63.9065 20.552C63.4492 20.9627 62.7865 21.168 61.9185 21.168ZM68.1784 21.168C67.385 21.168 66.8204 20.9393 66.4844 20.482C66.1577 20.0153 65.9944 19.4133 65.9944 18.676V15.4H65.0144V14.196L66.0784 14.126L66.2744 12.25H67.6184V14.126H69.3684V15.4H67.6184V18.676C67.6184 19.4787 67.9404 19.88 68.5844 19.88C68.7057 19.88 68.8317 19.866 68.9624 19.838C69.093 19.8007 69.205 19.7633 69.2984 19.726L69.5784 20.916C69.3917 20.9813 69.177 21.0373 68.9344 21.084C68.701 21.14 68.449 21.168 68.1784 21.168ZM71.684 21.168C71.3946 21.168 71.1473 21.0653 70.942 20.86C70.7366 20.6547 70.634 20.3933 70.634 20.076C70.634 19.7587 70.7366 19.4973 70.942 19.292C71.1473 19.0867 71.3946 18.984 71.684 18.984C71.9826 18.984 72.23 19.0867 72.426 19.292C72.622 19.4973 72.72 19.7587 72.72 20.076C72.72 20.3933 72.622 20.6547 72.426 20.86C72.23 21.0653 71.9826 21.168 71.684 21.168ZM74.6294 21V14.126H76.2394V21H74.6294ZM75.4414 12.922C75.1521 12.922 74.9188 12.838 74.7414 12.67C74.5641 12.502 74.4754 12.278 74.4754 11.998C74.4754 11.7273 74.5641 11.508 74.7414 11.34C74.9188 11.172 75.1521 11.088 75.4414 11.088C75.7308 11.088 75.9641 11.172 76.1414 11.34C76.3188 11.508 76.4074 11.7273 76.4074 11.998C76.4074 12.278 76.3188 12.502 76.1414 12.67C75.9641 12.838 75.7308 12.922 75.4414 12.922ZM81.1075 21.168C80.5382 21.168 80.0062 21.028 79.5115 20.748C79.0168 20.4587 78.6155 20.048 78.3075 19.516C77.9995 18.9747 77.8455 18.326 77.8455 17.57C77.8455 16.8047 77.9995 16.156 78.3075 15.624C78.6155 15.0827 79.0168 14.672 79.5115 14.392C80.0062 14.1027 80.5382 13.958 81.1075 13.958C81.6862 13.958 82.2228 14.1027 82.7175 14.392C83.2122 14.672 83.6135 15.0827 83.9215 15.624C84.2295 16.156 84.3835 16.8047 84.3835 17.57C84.3835 18.326 84.2295 18.9747 83.9215 19.516C83.6135 20.048 83.2122 20.4587 82.7175 20.748C82.2228 21.028 81.6862 21.168 81.1075 21.168ZM81.1075 19.852C81.6115 19.852 82.0082 19.642 82.2975 19.222C82.5868 18.802 82.7315 18.2513 82.7315 17.57C82.7315 16.8793 82.5868 16.324 82.2975 15.904C82.0082 15.484 81.6115 15.274 81.1075 15.274C80.6035 15.274 80.2068 15.484 79.9175 15.904C79.6375 16.324 79.4975 16.8793 79.4975 17.57C79.4975 18.2513 79.6375 18.802 79.9175 19.222C80.2068 19.642 80.6035 19.852 81.1075 19.852Z",
    fill: "#1D2730"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrkfstioLogo);
export default __webpack_public_path__ + "static/media/brkfstio-logo.80382ed251fbaf8d687e334d6c9bcdee.svg";
export { ForwardRef as ReactComponent };